import { useController } from 'react-hook-form';
import CategoryAutocompleteBase, {
  CategoryAutocompleteBaseProps,
  CategoryOption,
} from './category-autocomplete-base.component';

export type CategoryAutocompleteFieldProps<
  OptionType extends CategoryOption = CategoryOption,
> = {
  name: string;
} & CategoryAutocompleteBaseProps<OptionType>;

const CategoryAutocompleteField = <OptionType extends CategoryOption>({
  name,
  ...rest
}: CategoryAutocompleteFieldProps<OptionType>) => {
  const {
    field,
    fieldState: { error },
  } = useController({ name });

  return (
    <CategoryAutocompleteBase {...rest} value={field.value} error={error} />
  );
};

export default CategoryAutocompleteField;
